import { ProductModifierGroupDraft } from '@features/catalog/models/product-form-draft.models';

export function validateModifierGroupsDraft(
  groups: readonly ProductModifierGroupDraft[],
  hasActiveVariants: boolean,
): void {
  for (const group of groups) {
    const label = group.name.trim() || 'Modificador sin nombre';
    const activeOptions = group.options.filter((option) => option.name.trim().length > 0);

    if (group.required && group.minSelections < 1) {
      throw new Error(`"${label}" es obligatorio y requiere minimo 1 seleccion`);
    }

    if (group.selectionType === 'single') {
      if ((group.maxSelections ?? 1) > 1) {
        throw new Error(`"${label}" es de seleccion unica y no puede tener maximo mayor a 1`);
      }
      if (group.minSelections > 1) {
        throw new Error(`"${label}" es de seleccion unica y no puede tener minimo mayor a 1`);
      }
    }

    // Backend clamps maxSelections to active option count for multiple groups.
    // Do not block the form when catalog max exceeds the per-product subset.

    if (group.maxSelections != null && group.maxSelections < group.minSelections) {
      throw new Error(`"${label}" tiene un maximo menor que el minimo de selecciones`);
    }

    for (const option of activeOptions) {
      if (group.selectionType === 'quantity' && (option.maxQuantity == null || option.maxQuantity < 1)) {
        throw new Error(
          `"${option.name.trim() || 'Opcion'}" en "${label}" requiere cantidad maxima en modo cantidad`,
        );
      }

      if (option.variantPrices.length > 0 && !hasActiveVariants) {
        throw new Error(
          `Los precios por variante en "${option.name.trim() || 'Opcion'}" requieren variantes activas`,
        );
      }
    }
  }
}
